import React, { useState, useEffect } from "react";
import ResponsivePagination from "react-responsive-pagination";
import "./searchresults.scss";
import { Link } from "react-router-dom";
import OutsideClickHandler from "../../common/OutsideClickHandler";

const formatPracticeEmails = (emails) => {
  let practiceEmails = [];
  if (!emails) {
    practiceEmails = [];
  }

  if (typeof emails === "string") {
    practiceEmails = [emails];
  } else {
    practiceEmails = emails;
  }

  if (practiceEmails?.length > 1) {
    const firstEmail = practiceEmails.slice(0, 1).join(", ");
    const morePracticeEmails = practiceEmails.slice(1);
    return {
      firstEmail,
      morePracticeEmails,
    };
  } else {
    const firstEmail = practiceEmails?.join(", ");
    return {
      firstEmail,
      morePracticeEmails: [],
    };
  }
};

const formatPracticeUserEmails = (emails) => {
  let userEmails = [];
  if (!emails) {
    userEmails = [];
  }

  if (typeof emails === "string") {
    userEmails = [emails];
  } else {
    userEmails = emails;
  }

  return userEmails;
};

const PracticeSearchResults = ({
  practiceSearch,
  onPracticeUpdate,
  searchpracticeparams,
  practiceErrMsg,
}) => {
  const [searchResults, setSearchResults] = useState();
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedPhoneItem, setselectedPhoneItem] = useState(null);
  const [selectedTins, setSelectedTins] = useState(null);
  const totalPages = Math.ceil(practiceSearch?.totalItems / 10);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (practiceSearch?.items) {
      setSearchResults(practiceSearch["items"]);
    }
  }, [practiceSearch]);

  useEffect(() => {
    if (practiceErrMsg) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [practiceErrMsg]);

  const handleItemClick = (id) => () => {
    setSelectedItem(id === selectedItem ? null : id);
  };

  const handleTinItemClcik = (id) => () => {
    setSelectedTins(id === selectedTins ? null : id);
  }

  const handlePhoneItemClick = (id) => () => {
    setselectedPhoneItem(id === selectedPhoneItem ? null : id);
  };

  const maskNumber = (number) => {
    if (number) {
      const numStr = String(number);
      const maskedPart = "*".repeat(5);
      const unmaskedPart = numStr.substring(5);
      const maskedNumber = maskedPart + unmaskedPart;
      return maskedNumber;
    }
  };

  const renderTins = (item) => {
    if (!item?.tins?.length) {
      return null;
    }

    if (item?.tins?.length === 1) {
      return <p>{maskNumber(item.tins[0]?.tins)}</p>;
    }

    return (
      <>
        <OutsideClickHandler
          onClickOutside={() => {
            if (selectedTins === item?.displayId) {
              setSelectedTins(null);
            }
          }}
        >
          <p>{maskNumber(item?.tins[0])}</p>
          <a className="more-btn" onClick={handleTinItemClcik(item?.displayId)}>
            {" "}
            & {item?.tins?.length - 1} more
            {selectedTins === item?.displayId && (
              <span className="practice-popover-contect">
                <div className="arrow"></div>
                <ul className="more-list">
                  {item?.tins?.map((data, index) => (
                    <li key={index}>
                      <b>
                        {index + 1} of {item?.tins?.length} -{" "}
                      </b>
                      {maskNumber(data)}
                    </li>
                  ))}
                </ul>
              </span>
            )}
          </a>
        </OutsideClickHandler>
      </>
    );
  };

  const renderSearch = (item, index) => {
    const emailsToDisplayOnModal = [
      ...formatPracticeEmails(item.practiceEmails).morePracticeEmails,
      ...(item?.userEmails ? item.userEmails : []),
    ];
    return (
      <li key={index}>
        <div className="practice-info-right">
          <h3>
            <Link
              onClick={() => {
                // Clear search input when navigating
                const inputRef = document.querySelector('input[type="search"]');
                if (inputRef) {
                  inputRef.value = "";
                }
              }}
              to={`/practice/${item.displayId}/profile-information/info`}
            >
              {item?.name}
            </Link>
          </h3>
          <ul className="list-inline info-list">
            <li className="left-padding-zero">
              <label>Status</label>
              <p>{item?.state}</p>
            </li>
            <li>
              <label>Address</label>
              <p>
                {[
                  item?.streetAddress?.street1,
                  item?.streetAddress?.city,
                  item?.streetAddress?.state,
                  item?.streetAddress?.postalCode,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </p>
            </li>
            <li className="list-phone">
              <label>Phone</label>
              {item?.practicePhones?.length == 1 && (
                <p>{item?.practicePhones}</p>
              )}
              {item?.practicePhones?.length > 1 && (
                <>
                  <OutsideClickHandler
                    onClickOutside={() => {
                      if (selectedPhoneItem === item?.displayId) {
                        setselectedPhoneItem(null);
                      }
                    }}
                  >
                    <p>{item?.practicePhones[0]}</p>
                    <a
                      className="more-btn"
                      onClick={handlePhoneItemClick(item?.displayId)}
                    >
                      & {item?.practicePhones?.length - 1} more
                      {selectedPhoneItem === item?.displayId && (
                        <span className="practice-popover-contect">
                          <div className="arrow"></div>
                          <ul>
                            {item?.practicePhones?.map((item, index) => {
                              return (
                                <>
                                  {index > 0 && (
                                    <li>
                                      <b>phone:</b> {item}
                                    </li>
                                  )}
                                </>
                              );
                            })}
                          </ul>
                        </span>
                      )}
                    </a>
                  </OutsideClickHandler>
                </>
              )}
            </li>
            <li className="email-list">
              <label>Email</label>
              <p>{formatPracticeEmails(item.practiceEmails).firstEmail}</p>

              {emailsToDisplayOnModal?.length ? (
                <>
                  <OutsideClickHandler
                    isInLineFlex
                    onClickOutside={() => {
                      if (selectedItem === item?.displayId) {
                        setSelectedItem(null);
                      }
                    }}
                  >
                    <a
                      className="more-btn"
                      onClick={handleItemClick(item?.displayId)}
                      style={{
                        marginLeft: "2px",
                      }}
                    >
                      & {emailsToDisplayOnModal.length}
                      more
                      {selectedItem === item?.displayId && (
                        <span className="practice-popover-contect">
                          <div className="arrow"></div>
                          <ul>
                            {formatPracticeEmails(
                              item?.practiceEmails
                            )?.morePracticeEmails?.map((item) => {
                              return (
                                <>
                                  <li>
                                    <b>practice:</b> {item}
                                  </li>
                                </>
                              );
                            })}

                            {formatPracticeUserEmails(item?.userEmails)?.map(
                              (item) => {
                                return (
                                  <>
                                    <li><b>practice:</b></li>
                                    <li>
                                      <b>user:</b> {item}
                                    </li>
                                  </>
                                );
                              }
                            )}
                          </ul>
                        </span>
                      )}
                    </a>
                  </OutsideClickHandler>
                </>
              ) : null}
            </li>
            <li>
              <label>NPI (type 2)</label>
              <p>{item?.npiType2List}</p>
            </li>
            <li className="tin-list">
              <label>Tin</label>
              {renderTins(item)}
            </li>
          </ul>
        </div>
      </li>
    );
  };

  const RenderSearchError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {practiceErrMsg}
      </div>
    );
  };

  return (
    <div className="practice-list">
      {RenderSearchError()}
      {searchResults && (
        <>
          <ul className="search-list">
            {searchResults?.map((item, index) => {
              return renderSearch(item, index);
            })}
          </ul>
        </>
      )}

      {practiceSearch?.totalItems > 10 && (
        <div className="paginate-block">
          <ResponsivePagination
            total={totalPages}
            current={searchpracticeparams.pageNumber}
            onPageChange={(page) => onPracticeUpdate(page)}
            maxWidth={400}
          />
        </div>
      )}
    </div>
  );
};
export default PracticeSearchResults;
